(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-carousel-direction]');
    if (!button) return;
    var rail = document.getElementById(button.getAttribute('aria-controls'));
    if (!rail) return;
    var card = rail.querySelector('.p-category');
    var step = card ? card.getBoundingClientRect().width + 16 : 280;
    var direction = Number(button.getAttribute('data-carousel-direction'));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rail.scrollBy({ left: direction * step * 2, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
}());
